export default el => {    
    el.addEventListener('submit', (e) => {
        e.preventDefault();
        ajax(1);
    })

    const loading = (action = "") => {
        if (action == "add") {
            document.body.classList.add('loading');
        }

        else if (action == "remove") {
            document.body.classList.remove('loading');
        }

        else {
            document.body.classList.toggle('loading');
        }
    }

    const ajax = (paged = 1, scroll = false) => {
        const ajax_url = ParamsData.wp_ajax_url;
        const formData = new FormData(el);
        const xhr = new XMLHttpRequest();

        formData.append('action', 'searchbar');

        xhr.open('POST', ajax_url, true);

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 0)) {
                const response = JSON.parse(xhr.response);
                window.barba.go(response.url);
            }

            else {
            }
        };

        xhr.send(formData);
    }
};